// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"spinner_spinnerContainer__SLzrJ","spinner":"spinner_spinner__6LOe0","fullPage":"spinner_fullPage__czF4c","spin":"spinner_spin__zo8Zl"};